import { render, staticRenderFns } from "./PosMap.vue?vue&type=template&id=1131e562"
import script from "./PosMap.vue?vue&type=script&lang=js"
export * from "./PosMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports